export const namespaced = true;

export const state = {
  levelStats2: {
    correctas: 0,
    incorrectas: 0,
    puntuacion: 0,
    total: 0,
  },
};

export const mutations = {
  SET_LEVEL_STATS(state, payload) {
    state.levelStats2 = { ...state.levelStats2, ...payload };
  },
};

export const actions = {
  setLevelStats({ commit }, payload) {
    commit("SET_LEVEL_STATS", payload);
  },
};
